import React from 'react'
import _ from 'lodash'
import RADIAN from './radian'

export default ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
  theme,
}) => {
  if (percent < 0.04) return null
 	const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x  = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy  + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text
      x={x}
      y={y}
      fill={theme.colors.white}
      textAnchor='middle'
      dominantBaseline='central'
    >
    	{_.round(percent * 100)}%
    </text>
  )
}
